(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-loyalty-mobile-fix"]) return;
  try {
    
(function () {
  function compactText(value) {
    return (value || '').replace(/\s+/g, '').toLowerCase();
  }

  function fixLoginBox() {
    var login = document.querySelector('.ac-loyalty-redeem__login');
    if (!login) return;
    var box = login.closest('.ac-loyalty-redeem__box');
    if (box) box.classList.add('ac-loyalty-redeem__box--logged-out');
  }

  function hideBrokenCustomerBlock() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var nodes = document.querySelectorAll('h1,h2,h3,h4,h5,h6,p,div,span,strong');

    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (node.closest('.ac-loyalty') || node.closest('.ac-loyalty-redeem')) continue;

      var compact = compactText(node.textContent);
      if (compact.indexOf('denuestrosclientes') === -1) continue;

      var childHasMatch = false;
      for (var j = 0; j < node.children.length; j += 1) {
        if (compactText(node.children[j].textContent).indexOf('denuestrosclientes') !== -1) {
          childHasMatch = true;
          break;
        }
      }
      if (childHasMatch) continue;

      var block = node.closest('.shopify-section, section, [class*="review"], [class*="testimonial"], [class*="rating"], [class*="social-proof"], [class*="social_proof"], [class*="recent"]');
      var target = block || node;

      if (target && !target.querySelector('.ac-loyalty') && !target.querySelector('.ac-loyalty-redeem')) {
        target.style.setProperty('display','none','important');
        target.style.setProperty('height','0','important');
        target.style.setProperty('min-height','0','important');
        target.style.setProperty('margin','0','important');
        target.style.setProperty('padding','0','important');
        target.style.setProperty('overflow','hidden','important');
        target.setAttribute('data-ac-loyalty-hidden','true');
      } else {
        node.style.setProperty('display','none','important');
      }
    }
  }

  function applyFixes() {
    fixLoginBox();
    hideBrokenCustomerBlock();
  }

  function startFixes() {
    applyFixes();

    var observer = new MutationObserver(function () {
      applyFixes();
    });

    observer.observe(document.documentElement, {
      childList:true,
      subtree:true,
      characterData:true
    });

    window.addEventListener('load', applyFixes);
    window.addEventListener('resize', applyFixes);
    document.addEventListener('visibilitychange', applyFixes);

    [300,1000,2500,5000,10000,15000].forEach(function(delay){
      window.setTimeout(applyFixes, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startFixes);
  } else {
    startFixes();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac-loyalty-redeem"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-copy]');
  if (!button) return;
  const code = button.getAttribute('data-copy');
  navigator.clipboard.writeText(code).then(function() {
    const original = button.textContent;
    button.textContent = 'Copiado';
    setTimeout(function(){ button.textContent = original; }, 1600);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
